import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../ui/alert-dialog';

function formatUsd(cents) {
  return `$${(Number(cents) / 100).toLocaleString(undefined, { minimumFractionDigits: 2 })}`;
}

export default function PriceChangeConfirmDialog({
  open,
  onOpenChange,
  entityName,
  detail,
  onConfirm,
  confirming,
}) {
  if (!detail) return null;
  const changes = detail.changes || [];
  const first = changes[0];

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Confirm price change</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-2 text-sm text-slate-600 dark:text-slate-400">
              {first ? (
                <p>
                  You are changing <strong>{entityName}</strong> price from{' '}
                  <strong>{formatUsd(first.old_cents)}</strong> to{' '}
                  <strong>{formatUsd(first.new_cents)}</strong> ({first.billing_cycle}).
                </p>
              ) : (
                <p>You are changing pricing for <strong>{entityName}</strong>.</p>
              )}
              <p>
                This will affect <strong>{detail.affected_subscribers ?? 0}</strong> active
                subscriber(s) at their next renewal. They will be notified by email. New
                subscriptions will use the new price immediately. No mid-cycle proration.
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={confirming}>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} disabled={confirming}>
            {confirming ? 'Saving…' : 'Confirm & save'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
